import React from 'react'
import {Link} from 'react-router-dom'
import './index.scss'

const Step = ({step, steps, currentStep}) => {
  const allSteps = steps.map(s => s.step)
  const isDisabled = allSteps.indexOf(step.step) >= allSteps.indexOf(currentStep)

  const classNames = ['step']
  if (isDisabled) classNames.push('disabled')
  if (step.step === currentStep) classNames.push('current')

  return (
    <span className={classNames.join(' ').trim()}>
      {isDisabled && (
        <>{step.name}</>
      )}

      {!isDisabled && (
        <Link to={{
          pathname: step.path ? step.path : '/bestilling',
          search: `?step=${step.step}`
        }}>
          {step.name}
        </Link>
      )}
    </span>
  )
}

const OrderSteps = ({webOrder, steps, currentStep}) => {
  return (
    <div className="order-steps">
      {webOrder && webOrder.estate && (
        <span className="step">
          <Link to={`/oppdrag/${webOrder.estate.id}`}>
            {webOrder.estate.streetAddress}
          </Link>
        </span>
      )}
      {steps.map((step, i) => (
        <Step
          key={i}
          step={step}
          steps={steps}
          currentStep={currentStep}
        />
      ))}
    </div>
  )
}

export default OrderSteps
